export default "__VITE_ASSET__2EGdzLbA__"